export interface NavItem {
  label: string;
  to: string;
  enabled: boolean;
}

export const navItems: readonly NavItem[] = [
  { label: 'Projects', to: '/#projects', enabled: true },
  { label: 'Careers', to: '/careers', enabled: true },
  { label: 'Marketing', to: '/marketing', enabled: false },
  { label: 'AIGC', to: '/aigc', enabled: false },
];
